import { EditOutlined, GoogleOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Col, Flex, Typography, Tabs } from "antd";
import styled from "styled-components";

const { Title } = Typography;

export const Timestamp = styled.div`
  color: #9ca3af;
`;

export const StyledTitle = styled(Title)`
  margin: 0;
  font-size: 16px;
  font-weight: 400 !important;
`;

export const InnerFlex = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
`;

export const EditIcon = styled(EditOutlined)`
  font-size: 20px;
  cursor: pointer;
`;

export const ActivityIcon = styled.div`
  color: #6B7280;
  display: flex;
  align-items: center;

  svg {
    color: #6B7280;
  }
`;
